.brand {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  text-decoration: none;
}

/* The name is 0.65 of the mascot, and it is raised by a tenth of its size:
 * "psy" has descenders but no ascenders, so a centred line box leaves its
 * letters below the mascot's middle. Raised, the middle of the x-height
 * meets the middle of the brain (measured at 21, 24 and 26px). */
.name {
  font-size: calc(var(--size) * 0.65);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
  transform: translateY(-0.1em);
}

/* Hidden on a phone but still read: it names the link. */
@media (max-width: 719.98px) {
  .desktopName {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}
